var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16LiveStatCardYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 8,
    height: 12,
    rx: 2,
    fill: "#FFEB39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16LiveStatCardYellow);
export default __webpack_public_path__ + "static/media/kbv-v16-live-stat-card-yellow.afc4a25f166d8e0aef2628e353434d25.svg";
export { ForwardRef as ReactComponent };